import { render } from "./EventCard.vue?vue&type=template&id=0640f260&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=0640f260&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0640f260"

export default script